import React, { useEffect, useState } from "react";
import MemberLayout from "../components/MemberLayout";
import { api } from "../lib/api";
import { Card, CardContent } from "../components/ui/card";

export default function MemberHistory() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/scenarios/history").then(r => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <MemberLayout>
      <div className="haruki-fade-in">
        <h1 className="font-heading text-2xl font-bold sm:text-3xl">Your training history</h1>
        <p className="mt-2 text-sm text-muted-foreground">Only you can see this. Your agency cannot.</p>

        {items.length === 0 ? (
          <Card className="mt-6"><CardContent className="p-6 text-sm text-muted-foreground">No completed scenarios yet.</CardContent></Card>
        ) : (
          <div className="mt-6 space-y-3">
            {items.map((i) => (
              <Card key={i.log_id}>
                <CardContent className="p-5">
                  <div className="flex items-center justify-between text-xs text-muted-foreground">
                    <span>{i.completed_at?.slice(0, 10)}</span>
                    <span className="capitalize">{i.module_type?.replace(/_/g, " ")}</span>
                  </div>
                  <div className="mt-2 text-sm">
                    {i.incident_category?.replace(/_/g, " ")} · {i.emotional_beat?.replace(/_/g, " ")}
                  </div>
                  <div className="mt-2 text-xs uppercase tracking-widest" style={{
                    color: i.hmde_fallback ? "hsl(var(--muted-foreground))" :
                           i.hmde_zone === "resilience" ? "hsl(var(--haruki-leaf))" :
                           i.hmde_zone === "fire" ? "hsl(var(--haruki-fire))" :
                           "hsl(var(--haruki-neutral))",
                  }}>
                    {i.hmde_fallback ? "Not scored" :
                     i.hmde_zone === "resilience" ? "Resilience Zone" :
                     i.hmde_zone === "fire" ? "Emotional Fire Zone" : "Neutral Zone"}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </MemberLayout>
  );
}
